/** @flow */

import * as actions from "@modules/shared/constants/actions";
import * as absenceReasonsReducers from "./reducers";
import initialState from "./state";
import type { AlertsState } from "./types";
import { cloneObject } from "@utils/object";

export default (state: AlertsState = initialState, action: *): AlertsState => {
  const act = {
    [actions.GetAlerts]: absenceReasonsReducers.onGetAlerts,
    [actions.GetAlertsSuccess]: absenceReasonsReducers.onGetAlertsSuccess,
    [actions.GetAlertsError]: absenceReasonsReducers.onGetAlertsError,
  };

  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
